import { Autocomplete, TextField } from '@mui/material';
import { isEmptyString, withDefault } from '@weft/utils';
import VyDialog from 'apps/app/src/components/new-design/feedback/VyDialog';
import { useShareInvoiceToSlack } from 'apps/app/src/hooks/requests/use-slack';
import { useSlackGetUsers } from 'apps/app/src/hooks/requests/use-slack';
import { runMutation } from 'apps/app/src/utils/vy-mutation';
import { useState } from 'react';

type ShareInvoiceToSlackDialogProps = {
  open: boolean;
  onClose: () => void;
  invoiceId: string;

};

export const ShareInvoiceToSlackDialog: React.FC<
  ShareInvoiceToSlackDialogProps
> = ({ open, onClose, invoiceId }) => {
  const { data } = useSlackGetUsers({ suspense: true });
  const [selectedUserId, setSelectedUserId] = useState<string>('');

  const shareInvoiceToSlackMutation = useShareInvoiceToSlack();

  const handleShareInvoiceToSlack = async () => {
    await runMutation(shareInvoiceToSlackMutation, { userId: selectedUserId, invoice: invoiceId }, {
      pending: 'Sharing invoice to slack...',
      success: 'Invoice shared to slack',
      error: 'Failed to share invoice to slack',
    });
  };

  const onSubmit = async () => {
    await handleShareInvoiceToSlack();
    onClose();
    setSelectedUserId('');
  };

  return (
    <>
      <VyDialog
        open={open}
        onClose={onClose}
        label="Share Invoice with the team"
        cancelButtonText="Cancel"
        ctaDisabled={isEmptyString(selectedUserId)}
        ctaText="Share"
        onSubmit={onSubmit}
      >
        <Autocomplete
          options={withDefault(data?.users, [])}
          getOptionLabel={(user) => user.realName}
          onChange={(_event, user) => setSelectedUserId(user?.id ?? '')}
          renderInput={(params) => (
            <TextField
              {...params}
              label="slack member"
              size="medium"
              sx={{ padding: '15px' }}
            />
          )}
        />
      </VyDialog>
    </>
  );
};
